export default __webpack_public_path__ + "static/media/icon-hear-vision.349d6cd8.png";